import React from "react";
import "./style.scss";

const MenuHeader = ({children, className = ""}) => <p className={`menuHeaderText ${className}`}>{children}</p>;

export default MenuHeader;



// WEBPACK FOOTER //
// ./src/components/Sidebar/components/MenuHeader/index.jsx